import { NextPage } from 'next'
import Layout from '@layouts/Text'
import { TextBlock } from '@components/content'
import PageHeader from '@components/PageHeader'
import Link from '@components/Link'
import { H5 } from '@components/Heading'

const FrontEndDeveloper: NextPage = () => (
  <>
    <PageHeader title={[['Front-end/Wordpress', 'Developer']]} />

    <Layout>
      <TextBlock>
        <p>
          W związku z rozwojem naszej firmy, szukamy ambitnego i zdolnego
          Front-end developera, chcącego zasilić szeregi naszego zespołu.
        </p>

        <H5>Co będziesz robił?</H5>

        <ul>
          <li>wdrażał serwisy w oparciu o Wordpress / Joomla</li>
          <li>pracował w zespole przy większych, dedykowanych projektach</li>
          <li>rozwijał istniejące serwisy</li>
          <li>uczył się od starszych kolegów</li>
          <li>zarabiał pieniądze z przyjemnością</li>
        </ul>

        <H5>Czego oczekujemy?</H5>

        <ul>
          <li>wysokiej jakości kodu (atomizacja, SOLID, DRY)</li>
          <li>doświadczenia komercyjnego (minimum 1 rok)</li>
          <li>zapału i chęci rozwoju</li>
          <li>analitycznego myślenia</li>
          <li>umiejętności rozwiązywania problemów</li>
          <li>dobrej znajomości HTML, CSS/Sass, JavaScript</li>
          <li>Wordpress lub Joomla</li>
          <li>znajomości Git</li>
          <li>dobrej znajomości angielskiego (czytanie dokumentacji)</li>
          <li>mile widziany React oraz PHP</li>
        </ul>

        <H5>Jak działamy?</H5>

        <ul>
          <li>elastyczne godziny pracy w tym home office</li>
          <li>pracę przy ambitnych projektach</li>
          <li>płatne urlopy niezależnie od formy współpracy</li>
          <li>pracę w biurze w Poznaniu w 22 osobowym zespole</li>
          <li>niekorporacyjną atmosferę</li>
          <li>wspólne imprezy i spotkania</li>
          <li>chillroom, kuchnię</li>
          <li>budżet szkoleniowy</li>
          <li>pakiet multisport i pakiet medyczny</li>
        </ul>

        <H5>Stack technologiczny / narzędzia:</H5>

        <p>
          PHP / MySQL / JS / REACT / VUE / HTML / SASS / GIT / OOP / PHP7 /
          DOCKER / SCRUM / GITLAB / COMPOSER / SYMFONY / SYLIUS / UNIT TESTS /
          RABBIT MQ / REDIS / JIRA / KANBAN / CQRS / PAIR PROGRAMMING
        </p>
      </TextBlock>

      <TextBlock>
        <p>
          Prosimy o zamieszczenie następującej klauzuli w Państwa dokumentach:
        </p>
        <p>
          <em>
            Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych
            zawartych w dokumentach rekrutacyjnych dla celów naboru (zgodnie z
            ustawą o ochronie danych osobowych z 29 sierpnia 1997 r., Dz. U. nr
            133, poz. 883).
          </em>
        </p>

        <p>
          CV prosimy wysyłać na{' '}
          <Link href="mailto:hello@empressia.co">hello@empressia.co</Link>
        </p>
      </TextBlock>
    </Layout>
  </>
)

export default FrontEndDeveloper
